import { AdminLayout } from "@/views/layouts/AppLayout";
import { ActivityPage } from "@/views/pages/productActivity/ActivityPage";
import { ActivityOrderPage } from "@/views/pages/productActivity/ActivityOrderPage";
import { ActivityDetailPage } from "@/views/pages/productActivity/ActivityDetailPage";
import { ActivityFormPage } from "@/views/pages/productActivity/ActivityFormPage";
import { ActivityProductDetailPage } from "@/views/pages/productActivity/ActivityProductDetailPage";
import type { AdminRouteObject } from "../index";

/** 商品活动路由，先迁移活动列表并保留 Vue 历史详情/表单入口。 */
export const productActivityRoutes: AdminRouteObject = {
    path: "/productActivity",
    element: <AdminLayout />,
    handle: { title: "商品活动" },
    children: [
        {
            path: "activityList",
            element: <ActivityPage />,
            handle: {
                title: "活动列表",
                permissions: ["ROLE_ACTI_R", "ROLE_ACTI_W"],
                activeMenu: "/productActivity/activityList"
            }
        },
        {
            path: "activity/detail",
            element: <ActivityDetailPage />,
            handle: {
                title: "活动详情",
                permissions: ["ROLE_ACTI_R", "ROLE_ACTI_W"],
                activeMenu: "/productActivity/activityList"
            }
        },
        {
            path: "activity/add",
            element: <ActivityFormPage />,
            handle: {
                title: "新增活动",
                permissions: ["ROLE_ACTI_R", "ROLE_ACTI_W"],
                activeMenu: "/productActivity/activityList"
            }
        },
        {
            path: "activity/edit",
            element: <ActivityFormPage />,
            handle: {
                title: "编辑活动",
                permissions: ["ROLE_ACTI_R", "ROLE_ACTI_W"],
                activeMenu: "/productActivity/activityList"
            }
        },
        {
            path: "activityOrder",
            element: <ActivityOrderPage />,
            handle: {
                title: "活动订单",
                permissions: ["ROLE_ACTIORDER_R", "ROLE_ACTIORDER_W"],
                activeMenu: "/productActivity/activityOrder"
            }
        }
    ]
};

/**
 * 活动商品详情仍使用 Vue 时代的绝对地址，必须作为顶层路由注册，避免 React Router
 * 将绝对子路径错误地嵌套到 /productActivity 下并在应用启动时抛出异常。
 */
export const activityProductDetailHistoryRoutes: AdminRouteObject = {
    path: "/activityManagement",
    element: <AdminLayout />,
    handle: { title: "商品活动" },
    children: [
        {
            path: "activeGoodsDetail",
            element: <ActivityProductDetailPage />,
            handle: {
                title: "活动商品详情",
                permissions: ["ROLE_ACTI_R", "ROLE_ACTI_W"],
                activeMenu: "/productActivity/activityList"
            }
        }
    ]
};

export default productActivityRoutes;
